module.exports = __webpack_public_path__ + "images/play_large@3x.png?317f1002";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play_large@3x.png
// module id = 679
// module chunks = 7